import type { FC, InputHTMLAttributes } from 'react';

import { cn } from './cn.js';

export interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  /** Частичный выбор: отмечена часть вложенного, как у «выбрать все». */
  indeterminate?: boolean;
}

/**
 * Флажок - нативный input: клавиатура и программы чтения экрана работают без
 * доработок. Промежуточное состояние у нативного флажка - только свойство DOM,
 * атрибута нет, поэтому оно ставится через ref на каждом рендере.
 */
export const Checkbox: FC<CheckboxProps> = ({
  indeterminate = false,
  className,
  ...rest
}) => (
  <input
    type="checkbox"
    ref={(element) => {
      if (element !== null) element.indeterminate = indeterminate;
    }}
    className={cn(
      'size-4 shrink-0 cursor-pointer accent-brand-green disabled:cursor-not-allowed',
      className,
    )}
    {...rest}
  />
);
